module.exports = __webpack_public_path__ + "img/dg30.49a3cc56.png";